import {metadaApi} from '@dms/api/base';

import {
  GetHyundaiServiceInspectionMileagesApiArg,
  GetHyundaiServiceInspectionMileagesApiResponse,
  GetHyundaiServiceInspectionMileagesApiArgSchema,
  GetHyundaiServiceInspectionMileagesApiResponseSchema,
  GetHyundaiServiceInspectionModelsApiArg,
  GetHyundaiServiceInspectionModelsApiResponse,
  GetHyundaiServiceInspectionModelsApiArgSchema,
  GetHyundaiServiceInspectionModelsApiResponseSchema,
  PostHyundaiServiceInspectionCreateNewRequestToBasketApiArg,
  PostHyundaiServiceInspectionCreateNewRequestToBasketApiResponse,
  PostHyundaiServiceInspectionCreateNewRequestToBasketApiArgSchema,
  PostHyundaiServiceInspectionCreateNewRequestToBasketApiResponseSchema,
  PostHyundaiServiceInspectionCreateNewRequestToServiceOrderApiArg,
  PostHyundaiServiceInspectionCreateNewRequestToServiceOrderApiResponse,
  PostHyundaiServiceInspectionCreateNewRequestToServiceOrderApiArgSchema,
  PostHyundaiServiceInspectionCreateNewRequestToServiceOrderApiResponseSchema,
  PostHyundaiServiceInspectionReloadApiArg,
  PostHyundaiServiceInspectionReloadApiResponse,
  PostHyundaiServiceInspectionReloadApiArgSchema,
  PostHyundaiServiceInspectionReloadApiResponseSchema,
} from './types';

export const metadaHyundaiServiceInspectionApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getHyundaiServiceInspectionMileages: build.query<
      GetHyundaiServiceInspectionMileagesApiResponse,
      GetHyundaiServiceInspectionMileagesApiArg
    >({
      query: (queryArg) => ({
        url: `hyundai_omnetic/v1/v1/service-inspections/mileages`,
        params: {vehicle_id: queryArg.vehicleId},
        queryArg,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'hyundaiServiceInspectionMileages', id: queryArg.vehicleId},
      ],
      extraOptions: {
        responseSchema: GetHyundaiServiceInspectionMileagesApiResponseSchema,
        requestSchema: GetHyundaiServiceInspectionMileagesApiArgSchema,
      },
    }),
    getHyundaiServiceInspectionModels: build.query<
      GetHyundaiServiceInspectionModelsApiResponse,
      GetHyundaiServiceInspectionModelsApiArg
    >({
      query: (queryArg) => ({
        url: `hyundai_omnetic/v1/v1/service-inspections/models`,
        queryArg,
      }),
      providesTags: [{type: 'hyundaiServiceInspectionModels', id: 'LIST'}],
      extraOptions: {
        responseSchema: GetHyundaiServiceInspectionModelsApiResponseSchema,
        requestSchema: GetHyundaiServiceInspectionModelsApiArgSchema,
      },
    }),
    postHyundaiServiceInspectionCreateNewRequestToBasket: build.mutation<
      PostHyundaiServiceInspectionCreateNewRequestToBasketApiResponse,
      PostHyundaiServiceInspectionCreateNewRequestToBasketApiArg
    >({
      query: (queryArg) => ({
        url: `hyundai_omnetic/v1/v1/service-inspections/create-new-request-to-basket`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        'hyundaiServiceInspection',
        {type: 'serviceCase', id: queryArg.body.serviceCaseId ?? ''},
        {type: 'serviceJobs', id: queryArg.body.serviceCaseId ?? ''},
      ],
      extraOptions: {
        responseSchema: PostHyundaiServiceInspectionCreateNewRequestToBasketApiResponseSchema,
        requestSchema: PostHyundaiServiceInspectionCreateNewRequestToBasketApiArgSchema,
      },
    }),
    postHyundaiServiceInspectionCreateNewRequestToServiceOrder: build.mutation<
      PostHyundaiServiceInspectionCreateNewRequestToServiceOrderApiResponse,
      PostHyundaiServiceInspectionCreateNewRequestToServiceOrderApiArg
    >({
      query: (queryArg) => ({
        url: `hyundai_omnetic/v1/v1/service-inspections/create-new-request-to-service-order`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        'hyundaiServiceInspection',
        {type: 'serviceOrder', id: queryArg.body.serviceOrderId ?? ''},
        {type: 'serviceOrderJobs', id: queryArg.body.serviceOrderId ?? ''},
      ],
      extraOptions: {
        responseSchema: PostHyundaiServiceInspectionCreateNewRequestToServiceOrderApiResponseSchema,
        requestSchema: PostHyundaiServiceInspectionCreateNewRequestToServiceOrderApiArgSchema,
      },
    }),
    postHyundaiServiceInspectionReload: build.mutation<
      PostHyundaiServiceInspectionReloadApiResponse,
      PostHyundaiServiceInspectionReloadApiArg
    >({
      query: (queryArg) => ({
        url: `hyundai_omnetic/v1/v1/service-inspections/reload`,
        method: 'POST',
        body: {},
        queryArg,
      }),
      invalidatesTags: [
        'hyundaiServiceInspection',
        'hyundaiServiceInspectionMileages',
        'hyundaiServiceInspectionModels',
      ],
      extraOptions: {
        responseSchema: PostHyundaiServiceInspectionReloadApiResponseSchema,
        requestSchema: PostHyundaiServiceInspectionReloadApiArgSchema,
      },
    }),
  }),
});

export const {
  useGetHyundaiServiceInspectionMileagesQuery,
  useGetHyundaiServiceInspectionModelsQuery,
  usePostHyundaiServiceInspectionCreateNewRequestToBasketMutation,
  usePostHyundaiServiceInspectionCreateNewRequestToServiceOrderMutation,
  usePostHyundaiServiceInspectionReloadMutation,
} = metadaHyundaiServiceInspectionApi;
